import { Box, Text } from '@joinrepublic/dls-ui-kit';

export const MainLoggedOut = function MainLoggedOut() {
  return (
    <Box color="whiteAlpha.500">
      {/* // This refers to the stats banner (feature/global/src/components/stats/stats.tsx) */}
      <Text mb={4} size="body-sm" color="inherit">
        <Text as="sup" top="0" color="grey.400">
          *
        </Text>
        Includes funds deployed through investment platforms, funds, and firms
        within the Republic ecosystem.
      </Text>
      <Text mb={4} size="body-sm" color="inherit">
        <Text as="span" size="body-sm" color="inherit">
          1
        </Text>{' '}
        Represents users of republic.com, limited partners of Republic Capital
        Adviser LLC advised vehicles, users of europe.republic.com and clients
        of other affiliates.
      </Text>
      <Text mb={4} size="body-sm" color="inherit">
        <Text as="span" size="body-sm" color="inherit">
          2
        </Text>{' '}
        Includes aggregate figures from Republic and Seedrs platform to date,
        including investment opportunities presented by OpenDeal Portal LLC,
        OpenDeal Broker LLC, Republic Core LLC, Republic Deal Room Advisor LLC
        and Fig Publishing, Inc.
      </Text>
    </Box>
  );
};
